<div id="iposCentral" [ngClass]="setFont()" class="h-100" [dir]='direction'>
  <div id="accountPage" [ngClass]="{'account_page': layOut, 'author_page': isUserAuthor}"
    class="d-flex flex-column h-100">
    <iposcen-header *ngIf="layOut && !isUserAuthor"></iposcen-header>
    <div id="layout" *ngIf="!layOut" [ngClass]="setNavZIndex ? 'set-nav-index' : ''">
      <!-- Navbar starts here -->
      <nav class="navbar navbar-expand-lg navbar-dark first_nav" aria-labelledby="home">
        <a class="navbar-brand" [routerLink]="!isSrtAdmin ? ['home'] : ''" (click)=setHomeNavActive() *ngIf="!gameDemo">
          <img src="assets/images/Intel.png" alt="Intel Logo" />
          <span class="logo_text" i18n="@@app.top-nav.logo-text">IPOS CENTRAL</span>
        </a>
        <a class="navbar-brand" *ngIf="gameDemo" (click)=redirectToHome()
          [routerLink]="gameDemoPage ? homePageHref : env" target="{{gameDemoPage ? '_self' : '_blank'}}">
          <img src="assets/images/Intel.png" alt="Intel Logo" />
          <span class="logo_text" i18n="@@app.top-nav.logo-text">IPOS CENTRAL</span>
        </a>
        <div id="iposCentralHeader" [ngClass]="changePlacement ? 'ml-right' : 'ml-left'" *ngIf="gameDemo">
          <iposcen-header></iposcen-header>
        </div>
        <!-- Navbar toggle button - medium and below devices -->
        <button class="navbar-toggler" type="button" (click)="toggle()" [attr.aria-expanded]="isCollapsed"
        aria-controls="collapse">
          <span class="navbar-toggler-icon"></span>
         </button>
        <div class="collapse navbar-collapse" id="firstNavigation"  #collapse="ngbCollapse" [(ngbCollapse)]="!isCollapsed" *ngIf="!gameDemo">
          <!-- The following ul belongs to 2nd nav - visible on medium and below devices -->
          <ul class="navbar-nav ml-auto secondnav_duplicate d-block d-sm-block d-md-block d-lg-none d-xl-none"
            *ngIf="!isUserAuthor">
            <li class="nav-item" *ngIf="!(isSrtAdmin || deviceExecutiveRole)">
              <a class="nav-link" [routerLink]="homePageHref" [ngClass]="{'active': homePageTabIndex === 0 }">
                <span i18n="@@app.top-nav.home">Home</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="isAdmin && !hidePartnerContent">
              <a class="nav-link" [routerLink]="reviewPartnerContentHref" [ngClass]="{'active': homePageTabIndex === 9 }">
                <span i18n="@@app.top-nav.partner-content">Partner Content</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!isNonConnectedUser">
              <a class="nav-link" [routerLink]="deviceDashboardHref" [ngClass]="{'active': homePageTabIndex === 5 }">
                <span i18n="@@app.top-nav.devices">Devices</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!isNonConnectedUser && !deviceExecutiveRole">
              <a class="nav-link" [routerLink]="activeUsersHref" [ngClass]="{'active': homePageTabIndex === 1 }">
                <span i18n="@@app.top-nav.users">Users</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!deviceExecutiveRole">
              <a class="nav-link" [routerLink]="profileHref" [ngClass]="{'active': homePageTabIndex === 2 }">
                <span i18n="@@app.top-nav.profiles">Profiles</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!deviceExecutiveRole">
              <a class="nav-link" [routerLink]="assetLibraryHref" [ngClass]="{'active': homePageTabIndex === 3 }">
                <span i18n="@@app.top-nav.asset-library">Asset Library</span>
              </a>
            </li>
            <!--Commenting out for Feb release-->
            <li class="nav-item" *ngIf="!deviceExecutiveRole">
              <a class="nav-link" [routerLink]="skuIdsHref" (click)="setIndex(10)" [ngClass]="{'active': homePageTabIndex === 10 }">
                <span i18n="@@app.top-nav.skus">SKUs</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!deviceExecutiveRole">
              <a class="nav-link" [routerLink]="standardDownload" [ngClass]="{'active': homePageTabIndex === 4 }">
                <span>{{globalconst.STD_IPOS_HEADING}}</span>
              </a>
            </li>
          </ul>
          <!-- The following ul belongs to 1st navbar-->
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link gtmLearnMore" [routerLink]="helpHref" (click)="setIndex(8)"
                [ngClass]="{'activemenu': homePageTabIndex === 8 }">
                <img src="assets/images/firstnav_help_icon.svg" alt="help" />
                <span class="ml-1" [ngClass]="{'rtl-margin': isArabic || isHebrew}" i18n="@@app.global-nav.help">Help</span>
              </a>
            </li>
            <li class="nav-item" >
              <a *ngIf="!isSrtAdmin" class="nav-link gtmLang" [routerLink]="changeLanguage" (click)="setIndex(7)"
                [ngClass]="{'activemenu': homePageTabIndex === 7 }">
                <img src="assets/images/firstnav_lang_icon.svg" alt="language" />
                <span class="ml-1" [ngClass]="{'rtl-margin': isArabic || isHebrew}" i18n="@@app.global-nav.language">Language</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link gtmMyAccount" [routerLink]="myAccountHref" (click)="setIndex(6)"
                [ngClass]="{'activemenu': homePageTabIndex === 6 }">
                <span class="myaccount-img"></span>
                <span class="ml-1" [ngClass]="{'rtl-margin': isArabic || isHebrew}" i18n="@@app.global-nav.my-account">My Account</span>
              </a>
            </li>
            <li class="nav-item point-out">
              <a class="nav-link gtmLogOut" (click)="redirectToLogin()">
                <img src="assets/images/firstnav_logout_icon.svg" alt="logout" />
                <span class="ml-1" [ngClass]="{'rtl-margin': isArabic || isHebrew}" i18n="@@app.global-nav.logout">Log Out</span>
              </a>
            </li>
          </ul>
        </div> 
      </nav>
      <!-- Both navbar collapse into one for medium and below devices -->
      <!-- TODO: Test this for smaller screens-->
      <nav class="navbar navbar-expand-lg navbar-light second_nav" *ngIf="!isUserAuthor || isSrtAdmin"
        aria-label="navbar-smaller-res">
        <div id="regionalData" class="regional-logged" *ngIf="selectedRegionalData">
          <span class="logged-link" i18n="@@app.global-logged.logged-in-as">Logged-in as:</span>&nbsp;
          <div id="ngbdropDown" ngbDropdown class="btn-group">
            <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
              aria-haspopup="true" aria-expanded="false">
              {{ selectedRegionalData }}
            </button>
            <div id="ngbDropdownMenu" ngbDropdownMenu aria-labelledby="sizeDropDown">
              <ng-container *ngFor="let data of regionalDisplay">
                <a ngbDropdownItem (click)="selectRegionalList(data)" *ngIf="selectedRegionalData!=data">
                  {{data}}
                </a>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="collapse navbar-collapse" id="secondNavigation">
          <ul class="navbar-nav ml-auto" [ngClass]="{'create_retail_page' : hideSecondNav}">

            <li class="nav-item" *ngIf="!(isSrtAdmin || deviceExecutiveRole)">
              <a class="nav-link" href="#" [routerLink]="homePageHref" (click)="setIndex(0)"
                [ngClass]="{'active': homePageTabIndex === 0 }">
                <span i18n="@@app.top-nav.home">Home</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!(isSrtAdmin)">
              <a class="nav-link" href="#" [routerLink]="reviewPartnerContentHref" (click)="setIndex(9)"
                *ngIf="isAdmin && !hidePartnerContent && !deviceExecutiveRole" [ngClass]="{'active': homePageTabIndex === 9 }"><span
                  i18n="@@app.top-nav.partner-content">Partner Content</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" [routerLink]="deviceDashboardHref" (click)="setIndex(5)"
                *ngIf="!isNonConnectedUser" [ngClass]="{'active': homePageTabIndex === 5 }"><span
                  i18n="@@app.top-nav.devices">Devices</span></a>
            </li>
            <li class="nav-item" *ngIf="!(isSrtAdmin)">
              <a class="nav-link" href="#" [routerLink]="activeUsersHref" (click)="setIndex(1)"
                *ngIf="!isNonConnectedUser && !deviceExecutiveRole" [ngClass]="{'active': homePageTabIndex === 1 }"><span
                  i18n="@@app.top-nav.users">Users</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="profileHref" (click)="setIndex(2)" *ngIf="!deviceExecutiveRole"
                [ngClass]="{'active': homePageTabIndex === 2 }"><span i18n="@@app.top-nav.profiles">Profiles</span></a>
            </li>
            <li class="nav-item" *ngIf="!(isSrtAdmin || deviceExecutiveRole)">
              <a class="nav-link" [routerLink]="assetLibraryHref" (click)="setIndex(3)"
                [ngClass]="{'active': homePageTabIndex === 3 }"><span i18n="@@app.top-nav.asset-library">Asset
                  Library</span></a>
            </li>
            <!--Commenting out for Feb release-->
            <li class="nav-item" *ngIf="!deviceExecutiveRole">
              <a class="nav-link" [routerLink]="skuIdsHref" (click)="setIndex(10)"
                [ngClass]="{'active': homePageTabIndex === 10 }"><span i18n="@@app.top-nav.skus">SKUs</span></a>
            </li>
            <li class="nav-item" *ngIf="!(isSrtAdmin || deviceExecutiveRole)">
              <a class="nav-link" [routerLink]="standardDownload" (click)="setIndex(4)"
                [ngClass]="{'active': homePageTabIndex === 4 }" [innerHTML]="downloadIPOS"></a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <!-- Navbar ends here -->
    <div id="loginPage" class="flex-grow-1">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div id="profilePopup" *ngIf="showprofilePopup">
  <div id="profileModalDialog" class="modal-dialog modal-dialog-centered">
    <div id="modalDialogCenter" class="modal-dialog modal-dialog-centered" role="document">
      <div id="modalBackdrop" class="modal-backdrop show"></div>
      <div id="profileSwitchPopUp" class="modal profileSwitchPopUp">
        <div id="profileSwitchModalDialog" class="modal-dialog">
          <div id="profileSwitchModalContent" class="modal-content regional_modal_content">
            <div id="profileSwitchModalClose" class="close" data-dismiss="modal" (click)="closePopup()">
              <img class="modal-close-icon" alt="close" />
            </div>
            <div id="profileSwitchModalBody" class="modal-body">
              <div id="regionalCard" class="regional_card">
                <h2><span i18n="@@ipos-app.do-you-really-want-to-switch-to">Do you really want to switch to
                    {{showPopupdata}}?</span></h2>
                <div id="regionalCardDesc" class="card_desc">
                  <span i18n="@@ipos-app.unsaved-data">Any unsaved data would be lost. Please save your work before
                    proceeding.</span>
                </div>
              </div>
            </div>
            <div id="profileSwitchModalFooter" class="modal-footer card-footer">
              <button type="button" (click)="closePopup()" class="btn btn-outline-primary">
                <span>{{no}}</span>
              </button>
              <button type="button" class="btn btn-primary btn-yes" (click)="redirectToProfile()">
                <span>{{yes}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>